'use strict';

angular
  .module('appSettingOrderTutorial')
  .component('appSettingOrderTutorial', {
    template: require('./order-tutorial.template.html'),
    controller: ['$rootScope', '$resource', '$translate', 'AuthService', 'envService', 'Upload',
      function AppSettingOrderTutorialController($rootScope, $resource, $translate, AuthService, envService, Upload) {
        const APIURL = envService.read('apiUrl');

        $rootScope.mainmenu = 'appSetting';
        $rootScope.menu = 'orderTutorial';

        this.doLogout = $rootScope.gLogout;
        this.loginMember = AuthService.loginMember();
        this.isLevel2Auth = AuthService.canEditAppSettings();
        this.saving = false;
        this.countries = ['TH', 'KR', 'JP'];
        this.textLocales = ['en', 'th', 'ko', 'ja'];
        const memberCountry = (this.loginMember && this.loginMember.COUNTRY_CODE)
          ? String(this.loginMember.COUNTRY_CODE).toUpperCase()
          : 'TH';
        this.country = this.countries.indexOf(memberCountry) >= 0 ? memberCountry : 'TH';

        this._resolveTextLang = () => {
          let saved = null;
          try { saved = window.localStorage.getItem('omgAdminLang'); } catch (e) { saved = null; }
          const raw = String(
            saved
            || $translate.use()
            || $translate.proposedLanguage()
            || 'en'
          ).slice(0, 2).toLowerCase();
          if (raw === 'jp') return 'ja';
          if (this.textLocales.indexOf(raw) >= 0) return raw;
          return 'en';
        };
        this.textLang = this._resolveTextLang();
        this.textLangLabel = () => {
          const map = { en: 'EN', th: 'TH', ko: 'KO', ja: 'JA' };
          return map[this.textLang] || String(this.textLang || '').toUpperCase();
        };
        $rootScope.$on('$translateChangeSuccess', () => {
          this.applyTextToModel();
          this.textLang = this._resolveTextLang();
          this.syncTextFromModel();
          if (this.isLevel2Auth) {
            this.fillDefaults(false);
          }
        });

        this._emptyByLocale = () => {
          const out = {};
          this.textLocales.forEach((lang) => {
            out[lang] = [];
          });
          return out;
        };

        this._normalizeRow = (raw) => {
          const src = raw || {};
          const images = this._emptyByLocale();
          const srcImages = src.images || {};
          this.textLocales.forEach((lang) => {
            images[lang] = Array.isArray(srcImages[lang])
              ? srcImages[lang].slice()
              : [];
          });
          return { images };
        };

        this.rows = {
          TH: this._normalizeRow(null),
          KR: this._normalizeRow(null),
          JP: this._normalizeRow(null),
        };
        this.defaults = {
          TH: this._emptyByLocale(),
          KR: this._emptyByLocale(),
          JP: this._emptyByLocale(),
        };

        this.currentImages = () => {
          const row = this.rows[this.country];
          if (!row.images[this.textLang]) {
            row.images[this.textLang] = [];
          }
          return row.images[this.textLang];
        };

        this.urlsText = '';
        this.syncTextFromModel = () => {
          this.urlsText = this.currentImages().join('\n');
        };
        this.applyTextToModel = () => {
          const lines = String(this.urlsText || '')
            .split(/\n+/)
            .map((s) => s.trim())
            .filter(Boolean);
          this.rows[this.country].images[this.textLang] = lines;
        };

        this.removeAt = (index) => {
          this.applyTextToModel();
          const list = this.currentImages();
          if (index < 0 || index >= list.length) return;
          list.splice(index, 1);
          this.syncTextFromModel();
        };

        this.fillDefaults = (force) => {
          const defaults = ((this.defaults[this.country] || {})[this.textLang]) || [];
          if (!defaults.length) return;
          this.applyTextToModel();
          const cur = this.currentImages();
          if (force || !cur.length) {
            this.rows[this.country].images[this.textLang] = defaults.slice();
            this.syncTextFromModel();
          }
        };

        this.uploadImage = (files) => {
          if (!files || !files.length || !this.isLevel2Auth) return;
          Upload.upload({
            url: `${APIURL}/admin/file/order_confirm`,
            file: files[0],
          }).success((data) => {
            if (data && data.url) {
              this.applyTextToModel();
              this.currentImages().push(data.url);
              this.syncTextFromModel();
            }
          }).error(() => {
            alert($translate.instant('알수 없는 에러 입니다.'));
          });
        };

        this.load = () => {
          $resource(`${APIURL}/admin/services/apps/settings`)
            .get()
            .$promise
            .then((data) => {
              const defaults = (data && data.order_confirm_defaults) || {};
              this.countries.forEach((code) => {
                this.defaults[code] = Object.assign(
                  this._emptyByLocale(),
                  defaults[code] || {}
                );
              });
              const orderConfirm = (data && data.order_confirm) || {};
              this.countries.forEach((code) => {
                this.rows[code] = this._normalizeRow(orderConfirm[code]);
              });
              this.syncTextFromModel();
              if (this.isLevel2Auth) {
                this.fillDefaults(false);
              }
            })
            .catch((err) => {
              if (err.data && err.data.msg) alert(err.data.msg);
              else alert($translate.instant('알수 없는 에러 입니다.'));
            });
        };

        this.save = () => {
          if (!this.isLevel2Auth) return;
          if (!confirm($translate.instant('주문 확인 튜토리얼 설정을 저장하시겠습니까?'))) return;
          this.applyTextToModel();
          this.saving = true;
          const order_confirm = {};
          this.countries.forEach((code) => {
            order_confirm[code] = {
              images: this.rows[code].images,
            };
          });
          const Res = $resource(`${APIURL}/admin/services/apps/settings`, {}, {
            update: { method: 'PUT' },
          });
          Res.update({ order_confirm })
            .$promise
            .then((data) => {
              const saved = (data && data.order_confirm) || order_confirm;
              this.countries.forEach((code) => {
                this.rows[code] = this._normalizeRow(saved[code]);
              });
              this.syncTextFromModel();
              alert($translate.instant('수정되었습니다.'));
            })
            .catch((err) => {
              if (err.data && err.data.msg) alert(err.data.msg);
              else alert($translate.instant('알수 없는 에러 입니다.'));
            })
            .finally(() => {
              this.saving = false;
            });
        };

        this.load();
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/app-setting/order-tutorial/order-tutorial.component.js